import _ from 'lodash';
import { registerSettingConfig } from '@patsnap-biz/bio-search-setting';

type NwFieldConfig = {
    key: string;
    label: string;
    defaultValue: string | number;
};

type NwSettingStore = {
    settingValues?: {
        sequenceType?: string;
    };
    readFieldValue: (fieldName: string) => void;
    getSettingConfig: (fieldName: string) => { active: boolean } | undefined;
    writeFieldValue: (fieldName: string) => void;
};

const NW_FIELD_CONFIGS: Record<string, NwFieldConfig> = {
    nw_gap_extend: {
        key: 'gap_extend',
        label: 'Search.labels.gapExtend',
        defaultValue: 1,
    },
    nw_gap_open: {
        key: 'gap_open',
        label: 'Search.labels.gapOpen',
        defaultValue: 10,
    },
    nw_score_matrix: {
        key: 'score_matrix',
        label: 'Search.labels.scoreMatrix',
        defaultValue: 'BLOSUM62',
    },
    nw_match_score: {
        key: 'match_score',
        label: 'patent-view.lifescience.matchScore',
        defaultValue: 1,
    },
    nw_mis_match_score: {
        key: 'mis_match_score',
        label: 'patent-view.lifescience.misMatchScore',
        defaultValue: 0,
    },
};

const createFieldConfig = (fieldConfig: NwFieldConfig) => ({
    ...fieldConfig,
    getValue(settings: Record<string, unknown>) {
        const value = _.get(settings, fieldConfig.key);
        return value === undefined ? fieldConfig.defaultValue : value;
    },
    setValue(settings: Record<string, unknown>, value: unknown) {
        settings[fieldConfig.key] = value;
    },
});

export const registerNwFieldConfigs = () => {
    Object.entries(NW_FIELD_CONFIGS).forEach(([fieldName, config]) => {
        registerSettingConfig(fieldName, createFieldConfig(config));
    });
};

export const initializeNwFields = (store: NwSettingStore) => {
    const isNucleotide = store.settingValues?.sequenceType === 'NUCLEOTIDE';

    Object.keys(NW_FIELD_CONFIGS).forEach(fieldName => {
        if (!isNucleotide && ['nw_match_score', 'nw_mis_match_score'].includes(fieldName)) {
            return;
        }

        store.readFieldValue(fieldName);
        const config = store.getSettingConfig(fieldName);
        if (!config) return;

        config.active = true;
        store.writeFieldValue(fieldName);
    });
};
